import Download from "@mui/icons-material/CloudDownload";
import Share from "@mui/icons-material/Share";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import download from "downloadjs";
import { toPng } from 'html-to-image';
import QRCode from "qrcode.react";
import React, { Component } from "react";
const Logo = "/assets/images/logo-pernik-hsi.png";

class TicketItem extends Component {
  constructor(props) {
    super(props);
    this.state = props.ticket;
  }

  onUnduhClicked = () => {
    var node = document.getElementById(`ticket-${this.state.owner.name}`);
    toPng(node)
      .then(function(dataUrl) {
        // TODO: Please check if it is worked
        download(dataUrl, `$(this.state.owner.name}-Ticket.png`);
      })
      .catch(function(error) {
        console.error("oops, something went wrong!", error);
      });
  };

  onBagikanClicked = () => {
    var node = document.getElementById(`ticket-${this.state.owner.name}`);
    toPng(node)
      .then(function(dataUrl) {

        // TODO: Please check if it is worked
        if (navigator.share !== undefined) {
          navigator.share({
            title: "Share ticket",
            url: dataUrl
          });
        } else {
          download(dataUrl, `$(this.state.owner.name}-Ticket.png`);
        }
      })
      .catch(function(error) {
        console.error("oops, something went wrong!", error);
      });
  };

  renderKeyValue = (key, value) => {
    return (
      <div
        style={{
          marginLeft: 10,
          marginRight: 10,
          display: "flex",
          flexDirection: "row"
        }}
      >
        <div style={{ flex: 1, textAlign: "left" }}>{`${key} :`}</div>
        <div style={{ fontWeight: "bold" }}>{value}</div>
      </div>
    );
  };

  renderImages() {
    // TODO: Change with image from API.
    return (
      <div style={{ flex: 1, flexDirection: "row" }}>
        <img
          alt="produk"
          src={Logo}
          style={{
            height: 50,
            width: 50,
            borderRadius: "10px 10px 0 0",
            borderWidth: 1,
            borderColor: "black"
          }}
        />
        <img
          alt="produk"
          src={Logo}
          style={{
            height: 50,
            width: 50,
            borderRadius: "10px 10px 0 0",
            borderWidth: 1,
            borderColor: "black"
          }}
        />
        <img
          alt="produk"
          src={Logo}
          style={{
            height: 50,
            width: 50,
            borderRadius: "10px 10px 0 0",
            borderWidth: 1,
            borderColor: "black"
          }}
        />
        <img
          alt="produk"
          src={Logo}
          style={{
            height: 50,
            width: 50,
            borderRadius: "10px 10px 0 0",
            borderWidth: 1,
            borderColor: "black"
          }}
        />
      </div>
    );
  }

  render() {
    return (
      <div
        className="ticket"
        style={{ display: "flex", flexDirection: "column", marginBottom: 20 }}
      >
        <div id={`ticket-${this.state.owner.name}`}>
          <div style={{ backgroundColor: "white" }}>
            <div style={{ marginTop: 10, textAlign: "center", padding: 10 }}>
              <QRCode value={this.state.qrCodeValue} />
            </div>
            <div>{this.state.title}</div>
          </div>
          <Divider style={{ marginTop: 10, marginBottom: 10, width: 300 }} />
          {this.renderKeyValue("Status", this.state.status)}
          {this.renderKeyValue("Nomor Transaksi", this.state.noTransaction)}
          {this.renderKeyValue("Dibayar pada", this.state.paid_at)}
          <Divider style={{ marginTop: 10, marginBottom: 10, width: 300 }} />
          {this.renderKeyValue("Nama", this.state.owner.name)}
          {this.renderKeyValue(
            "Jenis Kelamin",
            this.state.owner.gender === "male" ? "Laki-laki" : "Perempuan"
          )}
          {this.renderKeyValue(
            "Nomor Handphone",
            this.state.owner.phone !== ""
              ? this.state.owner.phone
              : "-"
          )}
          {this.renderKeyValue(
            "Email",
            this.state.owner.email !== ""
              ? this.state.owner.email
              : "-"
          )}
          <Divider style={{ marginTop: 10, marginBottom: 10, width: 300 }} />
        </div>
        {this.renderImages()}
        <div
          style={{
            flex: 1,
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <Button
            onClick={this.onUnduhClicked}
            variant="contained"
            color="primary"
            startIcon={<Download />}
            style={{
              textTransform: "none",
              height: 35,
              width: 100,
              alignSelf: "center",
              marginBottom: 10,
              marginHorizontal: 10
            }}
          >
            Unduh
          </Button>
          <Button
            onClick={this.onBagikanClicked}
            variant="contained"
            color="primary"
            startIcon={<Share />}
            style={{
              textTransform: "none",
              height: 35,
              width: 100,
              alignSelf: "center",
              marginBottom: 10,
              marginHorizontal: 10,
              marginLeft: 20
            }}
          >
            Bagikan
          </Button>
        </div>
      </div>
    );
  }
}

export default TicketItem;
